import { render } from "./SwitchButton.vue?vue&type=template&id=02bb0d3d&ts=true"
import script from "./SwitchButton.vue?vue&type=script&lang=ts"
export * from "./SwitchButton.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__